import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Loading from '../Shared/Loading';
import BookingModal from './BookingModal';
import Service from './Service';

const AvailableAppointments = ({ date }) => {

    const [treatment, setTreatment] = useState(null)
    const formattedDate = format(date, 'PP');
    // useEffect(() => {
    //     fetch(`https://doctors-portal-1324.herokuapp.com/available?date=${formattedDate}`)
    //         .then(res => res.json())
    //         .then(data => setServices(data))
    // }, [formattedDate])

    // user query

    const { data: services, isLoading, refetch } = useQuery(['available', formattedDate], () => fetch(`https://doctors-portal-1324.herokuapp.com/available?date=${formattedDate}`)
        .then(res => res.json()))


    if (isLoading) {
        return <Loading />
    }

    return (
        <div className='py-20'>
            <p className='text-xl text-center text-secondary font-bold mb-10'>Available Appointment on: {format(date, 'PP')} </p>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
                {
                    services.map((service) => <Service
                        key={service._id}
                        service={service}
                        setTreatment={setTreatment}
                    />)
                }
            </div>
            {treatment && <BookingModal
                date={date}
                treatment={treatment}
                setTreatment={setTreatment}
                refetch={refetch} />}
        </div>
    );
};

export default AvailableAppointments;